<svelte:window onkeydown={handleKeydown} />
<div class="w-full rounded-[36px] bg-[#ffffff] flex items-center gap-[16px] h-[72px] max-mobile:h-[56px] max-mobile:pr-[16px]">
    <input placeholder={$t('input.placeholder')}
        bind:this={linkInput}
        oninput={() => (isFocused = true)}
        onfocus={() => (isFocused = true)}
        onblur={() => (isFocused = false)}
        class="h-full pl-[20px] flex-1 bg-[transparent] text-[20px] text-[#000000] max-mobile:text-[16px]"
        bind:value={$link}
     />
     
     {#if clearVisible}
        <ClearButton click={clearData} />
     {:else}
      <ClipboardButton click={pasteClipboard}/>
     {/if}
     <DownloadButton 
            className="max-mobile:!hidden"
            url={$link}
            bind:disabled={isDisabled}
            bind:loading={isLoading}/>
</div>
<div class="mobile:hidden py-[20px]">
    <DownloadButton 
            className="!w-full !h-[52px]"
            url={$link}
            bind:disabled={isDisabled}
            bind:loading={isLoading}/>
</div>
<script lang="ts">
    import ClipboardButton from '$components/downloadInputArea/buttons/ClipboardButton.svelte'
    import DownloadButton from '$components/downloadInputArea/buttons/DownloadButton.svelte'
    import ClearButton from '$components/downloadInputArea/buttons/ClearButton.svelte'
    import { link } from "$lib/state/omnibox";
    import dialogs from "$lib/state/dialogs";
    import { killDialog } from "$lib/state/dialogs";
    import { hapticSwitch } from "$lib/haptics";
    import { pasteLinkFromClipboard } from "$lib/clipboard";
    import { tick } from "svelte";
    import { savingHandler } from "$lib/api/saving-handler";
    import type { Optional } from "$lib/types/generic";
    import { downloadButtonState } from "$lib/state/omnibox";
    import { t } from "$lib/i18n/translations";
    
    let linkInput: Optional<HTMLInputElement>;

    let isFocused = $state(false);
    let isDisabled = $state(false);
    let isLoading = $state(false);


    // 重置状态
    const resetState = () => {
        downloadButtonState.set('idle')
         killDialog()
    };

    const validLink = (url: string) => {
        try {
            return /^https?\:/i.test(new URL(url).protocol);
        } catch {}
    };

    $effect (() => {
        let isValid = validLink($link)
        if(isValid){
            isDisabled = false
        } else {
            isDisabled = true

        }
    })
    let clearVisible = $derived($link && !isLoading);

    const pasteClipboard = async () => {
        resetState()
        // if (isDisabled || isLoading) {
        //     return;
        // }

        hapticSwitch();


        const pastedData = await pasteLinkFromClipboard();
        if (!pastedData) return;

        console.log('Pasted data:', pastedData);

        const linkMatch = pastedData.match(/https?\:\/\/[^\s]+/g);

        if (linkMatch) {
            $link = linkMatch[0].split('，')[0];
            await tick(); // wait for button to render
            savingHandler({ url: $link });
        }
    };
     const handleKeydown = (e: KeyboardEvent) => {
        if (!linkInput || $dialogs.length > 0 || isDisabled || isLoading) {
            return;
        }

        if (e.metaKey || e.ctrlKey || e.key === "/") {
            linkInput.focus();
        }

        if (e.key === "Enter" && validLink($link) && isFocused) {
            resetState()
            savingHandler({ url: $link });
        }

        if (["Escape", "Clear"].includes(e.key) && isFocused) {
            $link = "";
        }

        if (e.target === linkInput) {
            return;
        }

        switch (e.key) {
            case "D":
                pasteClipboard();
                break;
            default:
                break;
        }
    };

    const clearData = () => {
        $link = "";
        // resetState()
    };
</script>
<style lang="less">
    .download-btn {
        width: 230px;
        height: 64px;
        border-radius: 32px;
        background: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        font-weight: bold;
        color: #fff;
    }
</style>